<template>
  <div class="content" style="padding-top:0px">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="d-block">
            <router-link :to="{ name: 'pelanggan-tambah'}"  class="btn btn-sm btn-success">Tambah Pelanggan</router-link>
            <router-link :to="{ name: 'pelanggan-import'}"  class="btn btn-sm btn-danger">Import Pelanggan</router-link>
            <router-link :to="{ name: 'pelanggan-singkron'}"  class="btn btn-sm btn-info">Singkronkan dengan Mikrotik</router-link>
          </div>
          <small>NB : Klik panah kanannya</small>
          <div class="box-horizontal">
            <div class="box-horizontal menu-icon mr-2 mb-0">
              <div>
                <span>
                  Pelanggan 
                  <span class="badge badge-secondary" v-if="data.totalPelanggan == null"> &#8226;&#8226; </span> 
                  <span class="badge badge-secondary" v-else> {{data.totalPelanggan}} </span> 
                </span><br>
                <div class="box-horizontal mb-0">
                  <span v-if="data.PelangganUang != '0'">{{myGlobal.ribu(data.PelangganUang)}}</span>
                  <span v-else>&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</span>
                  <i class="material-icons ml-2 text-info pointer" style="font-size: 14pt;" @click="get.dataTotalUang('all')">remove_red_eye</i>
                </div>
              </div>
              <router-link :to="{ name: 'pelanggan'}" class="ml-2 pt-2 pb-2 pointer text-info" @click.native="get.datae('all')"> 
                <i class="material-icons">chevron_right</i>
              </router-link>
            </div>
            <div class="box-horizontal menu-icon mr-2 mb-0">
              <div>
                <span class=" text-warning">
                  Belum Bayar 
                  <span class="badge badge-warning" v-if="data.totalBelum == null">&#8226;&#8226;</span> 
                  <span class="badge badge-warning" v-else> {{data.totalBelum}} </span> 
                </span><br>
                <div class="box-horizontal mb-0">
                  <span v-if="data.BelumUang != '0'">{{myGlobal.ribu(data.BelumUang)}}</span>
                  <span v-else>&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</span>
                  <i class="material-icons ml-2 text-info pointer" style="font-size: 14pt;" @click="get.dataTotalUang('belum')">remove_red_eye</i>
                </div>
              </div>
              <router-link :to="{ name: 'pelanggan-belum'}" class="ml-2 pt-2 pb-2 pointer text-warning" @click.native="get.datae('belum')"> 
                <i class="material-icons">chevron_right</i>
              </router-link>
            </div>
            <div class="box-horizontal menu-icon mr-2 mb-0">
              <div>
                <span class="text-success">
                  Lunas Bayar
                  <span class="badge badge-warning" v-if="data.totalLunasNow == null">&#8226;&#8226;</span> 
                  <span class="badge badge-warning" v-else> {{data.totalLunasNow}} </span> 
                </span><br>
                <div class="box-horizontal mb-0">
                  <span v-if="data.LunasNowUang != '0'">{{myGlobal.ribu(data.LunasNowUang)}}</span>
                  <span v-else>&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</span>
                  <i class="material-icons ml-2 text-info pointer" style="font-size: 14pt;" @click="get.dataTotalUang('lunasnow')">remove_red_eye</i>
                </div>
              </div>
              <router-link :to="{ name: 'pelanggan-lunas-now'}" class="ml-2 pt-2 pb-2 pointer text-success" @click.native="get.datae('lunasnow')"> 
                <i class="material-icons">chevron_right</i>
              </router-link>
            </div>
            <div class="box-horizontal menu-icon mr-2 mb-0">
              <div>
                <span class="text-success">
                  Transaksi Cash 
                  <span class="badge badge-warning" v-if="data.totalLunasCash == null">&#8226;&#8226;</span> 
                  <span class="badge badge-warning" v-else> {{data.totalLunasCash}} </span> 
                </span><br>
                <div class="box-horizontal mb-0">
                  <span v-if="data.LunasCashUang != '0'">{{myGlobal.ribu(data.LunasCashUang)}}</span>
                  <span v-else>&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</span>
                  <i class="material-icons ml-2 text-info pointer" style="font-size: 14pt;" @click="get.dataTotalUang('lunas')">remove_red_eye</i>
                </div>
              </div>
              <router-link :to="{ name: 'pelanggan-lunas'}" class="ml-2 pt-2 pb-2 pointer text-success" @click.native="get.datae('lunas')"> 
                <i class="material-icons">chevron_right</i>
              </router-link>
            </div>
            <div class="box-horizontal menu-icon mr-2 mb-0">
              <div>
                <span class="text-success">
                  Transaksi Online 
                  <span class="badge badge-warning" v-if="data.totalLunasOnline == null">&#8226;&#8226;</span> 
                  <span class="badge badge-warning" v-else> {{data.totalLunasOnline}} </span> 
                </span><br>
                <div class="box-horizontal mb-0">
                  <span v-if="data.totalLunasOnlineUang != '0'">{{myGlobal.ribu(data.totalLunasOnlineUang)}}</span>
                  <span v-else>&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</span>
                  <i class="material-icons ml-2 text-info pointer" style="font-size: 14pt;" @click="get.dataTotalUang('lunas_online')">remove_red_eye</i>
                </div>
              </div>
              <router-link :to="{ name: 'pelanggan-lunas-online'}" class="ml-2 pt-2 pb-2 pointer text-success" @click.native="get.datae('lunas-online')"> 
                <i class="material-icons">chevron_right</i>
              </router-link>
            </div>
          </div>
          <!--
          <router-link :to="{ name: 'pelanggan-lunas-online'}" class="btn btn-secondary" @click.native="get.datae('lunas-online')"> 
            <span class=" text-success">Transaksi Online <span class="badge badge-success">{{data.totalLunasOnline}}</span></span><br>
            <span>{{myGlobal.ribu(data.totalLunasOnlineUang)}}</span>
          </router-link>
          <router-link :to="{ name: 'pelanggan-lunas'}" class="btn btn-secondary" @click.native="get.datae('lunas')">
            <span class=" text-success">Transaksi Cash <span class="badge badge-success">{{data.totalLunasCash}}</span></span><br>
            <span>{{myGlobal.ribu(data.LunasCashUang)}}</span>
          </router-link>
          <router-link :to="{ name: 'pelanggan'}" class="btn btn-secondary" @click.native="get.datae('all')">
            Pelanggan <span class="badge badge-primary">{{data.totalPelanggan}}</span><br>
            <span>{{myGlobal.ribu(data.PelangganUang)}}</span>
          </router-link>
          <router-link :to="{ name: 'pelanggan-lunas-now'}" class="btn btn-secondary" @click.native="get.datae('lunas')">
            <span class=" text-success">Lunas Bayar <span class="badge badge-success">{{data.totalLunasNow}}</span></span><br>
            <span>{{myGlobal.ribu(data.LunasNowUang)}}</span>
          </router-link>
          -->
          <router-link :to="{ name: 'pelanggan-baru', params: { filter:'new' }}" class="btn btn-secondary" @click.native="get.datae('baru')">
            Pelanggan Baru <span class="badge badge-info">{{data.totalPelangganBaru}}</span>
          </router-link>
          <router-link :to="{ name: 'pelanggan-telat', params: { filter:'telat' }}" class="btn btn-secondary" @click.native="get.datae('telat')">
            Telat <span class="badge badge-warning">{{data.totalTelat}}</span>
          </router-link>
          <router-link :to="{ name: 'pelanggan-nunggak', params: { filter:'nunggak' }}" class="btn btn-secondary" @click.native="get.datae('nunggak')">
            Nunggak <span class="badge badge-warning">{{data.totalNunggak}}</span>
          </router-link>
          <router-link :to="{ name: 'pelanggan-isolir'}" class="btn btn-secondary" @click.native="get.datae('isolir')">
            Cuti / Isolir <span class="badge badge-danger" style="font-size:8pt">{{data.totalIsolir}}</span>
          </router-link>
          <router-link :to="{ name: 'pelanggan-transaksi-isolir'}" class="btn btn-secondary" @click.native="get.datae('isolir')">
            Transaksi Isolir <span class="badge badge-danger" style="font-size:8pt">{{data.isolirTotal}}</span>
          </router-link>
          <router-link :to="{ name: 'pelanggan-berhenti'}" class="btn btn-secondary" @click.native="get.datae('berhenti')">
            Pelanggan Berhenti <span class="badge badge-danger" style="font-size:8pt">{{data.berhentiTotal}}</span>
          </router-link>
        </div>
      </div>
      <div class="row">

          <div class="col-md-12">

          <h3 class="m-0 mt-3" style="margin-bottom: 10px !important">
            {{data.title}} 
          </h3>

            <transition name="slide-fade" mode="out-in"><router-view :key="$route.fullPath"></router-view></transition>
          </div>
      </div>     

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import inter from '@/globalFunc/Interface' 
import myGlobal from '@/globalFunc/myGlobal' 
import Loading from '@/globalFunc/Loading' 
import { reactive } from '@vue/composition-api'
import { RedisSession } from '@/globalFunc/redis';

Vue.use(moment)

// EXCEL
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
    name: 'Beranda', 
    components: { 
        vuejsDatepicker,
        moment,
        'Loading': Loading
    },
    setup() {
        const data = reactive({
          ppn: '',
          infoShow: -1,
          
          totalPelanggan: null,
          PelangganUang: "0",
          
          totalBelum: null,
          BelumUang: '0',

          totalLunasNow: null,
          LunasNowUang: "0",

          totalLunasCash: null,
          LunasCashUang: '0',

          totalLunasOnline: null,
          totalLunasOnlineUang: '0',

          totalPelangganBaru: '0',

          totalIsolir: '0',
          isolirTotal: '0',
          berhentiTotal: '0',

          title: "Pelanggan",
          page: "all",

          totalTelat: '0',
          totalNunggak: '0'
        })

        const get = {
          coba() {
            alert("lur")
          },
          dataTotal() {

            let cacheT = "pel_ppoe"; // REDIS ====================================
            const cached = RedisSession.get(cacheT);
            if (cached) {
                let x = cached;

                // LANJUT DI BAWAH
                if (x.status) {

                  data.totalPelangganBaru = x.data.baru;
                  //data.totalIsolir = x.data.isolir;
                  //data.isolirTotal = x.data.isolirTotal;
                  //data.berhentiTotal = x.data.berhenti;
                }

                myGlobal.loger("dari radis "+cacheT);

                return false;
            }
            myGlobal.loger("baru "+cacheT);
            
            var datax = {
              token: 'TangTung '+sessionStorage.getItem('myToken'),
              bulan: myGlobal.getBulan(),
              tahun: myGlobal.getTahunNow()
            }
            
            var apiUrl = inter.BerandaPPOE();
            myGlobal.call(datax,apiUrl).then(x => {

              RedisSession.set(cacheT, x, 600000); // 10 menit

              // console.log(JSON.stringify(x));

              if (x.status) {

                data.totalPelangganBaru = x.data.baru;
                //data.totalIsolir = x.data.isolir;
                //data.isolirTotal = x.data.isolirTotal;
                //data.berhentiTotal = x.data.berhenti;
              }
            });

          },
          dataTotalUang(tipe) {
    
              let cacheT = "pel_total_uang-"+tipe; // REDIS ====================================
              const cached = RedisSession.get(cacheT);
              if (cached) {
                  let x = cached;

                  // LANJUT DI BAWAH
                  if (x.status) {
                    // all
                    if (tipe == 'all') {

                      RedisSession.set(cacheT, x, 300000); // 5 menit

                      data.totalPelanggan = parseInt(x.data.user) - parseInt(x.data.baru);
                      data.PelangganUang = x.data.userUang; 
                    }

                    // belum
                    if (tipe == 'belum') {

                      RedisSession.set(cacheT, x, 300000); // 5 menit

                      data.totalBelum = x.data.belum;
                      data.BelumUang = x.data.belumUang;
                    }

                    // lunasnow // lunas bayar
                    if (tipe == 'lunasnow') {

                      RedisSession.set(cacheT, x, 300000); // 5 menit

                      data.totalLunasNow = x.data.lunasnow;
                      data.LunasNowUang = x.data.lunasnowUang;
                    }

                    // lunas // transaksi cash
                    if (tipe == 'lunas') {

                      RedisSession.set(cacheT, x, 300000); // 5 menit

                      data.totalLunasCash = x.data.lunas;
                      data.LunasCashUang = x.data.lunasUangCash;
                    }

                    // lunas_online // transaksi online
                    if (tipe == 'lunas_online') {

                      RedisSession.set(cacheT, x, 300000); // 5 menit
                      
                      data.totalLunasOnline = x.data.lunasOnline;
                      data.totalLunasOnlineUang = x.data.lunasOnlineUangCash;
                    }

                    //data.totalPelangganBaru = x.data.baru;
                    //data.totalIsolir = x.data.isolir;
                    //data.isolirTotal = x.data.isolirTotal;
                  }

                  myGlobal.loger("dari radis "+cacheT);

                  return false;
              }
              myGlobal.loger("baru "+cacheT);

              var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken'),
                bulan: myGlobal.getBulan(),
                tahun: myGlobal.getTahunNow(),
                tipe: tipe
              }
              
              var apiUrl = inter.getDashboardPPOEUang();
              myGlobal.call(datax,apiUrl).then(x => {

                //myGlobal.logerNo(JSON.stringify(x));

                if (x.status) {
                  // all
                  if (tipe == 'all') {

                    RedisSession.set(cacheT, x, 300000); // 5 menit

                    data.totalPelanggan = parseInt(x.data.user) - parseInt(x.data.baru);
                    data.PelangganUang = x.data.userUang; 
                  }

                  // belum
                  if (tipe == 'belum') {

                    RedisSession.set(cacheT, x, 300000); // 5 menit

                    data.totalBelum = x.data.belum;
                    data.BelumUang = x.data.belumUang;
                  }

                  // lunasnow // lunas bayar
                  if (tipe == 'lunasnow') {

                    RedisSession.set(cacheT, x, 300000); // 5 menit

                    data.totalLunasNow = x.data.lunasnow;
                    data.LunasNowUang = x.data.lunasnowUang;
                  }

                  // lunas // transaksi cash
                  if (tipe == 'lunas') {

                    RedisSession.set(cacheT, x, 300000); // 5 menit

                    data.totalLunasCash = x.data.lunas;
                    data.LunasCashUang = x.data.lunasUangCash;
                  }

                  // lunas_online // transaksi online
                  if (tipe == 'lunas_online') {

                    RedisSession.set(cacheT, x, 300000); // 5 menit

                    data.totalLunasOnline = x.data.lunasOnline;
                    data.totalLunasOnlineUang = x.data.lunasOnlineUangCash;
                  }

                  //data.totalPelangganBaru = x.data.baru;
                  //data.totalIsolir = x.data.isolir;
                  //data.isolirTotal = x.data.isolirTotal;
                }
              });
          },
          getDataTelat(tipe) {
              let cacheT = "pel_nunggak"; // REDIS ====================================
              const cached = RedisSession.get(cacheT);
              if (cached) {
                  let x = cached;

                  // LANJUT DI BAWAH
                  if (x.status) {

                    var datax = x.data;
                    data.totalTelat = datax.telat;
                    data.totalNunggak = datax.nunggak;

                  }

                  myGlobal.loger("dari radis "+cacheT);

                  return false;
              }
              myGlobal.loger("baru "+cacheT);
              
              var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken')
              }
              
              var apiUrl = inter.PelangganNunggakTelat();
              myGlobal.call(datax,apiUrl).then(x => {
                //console.log(JSON.stringify(x));
                RedisSession.set(cacheT, x, 600000); // 10 menit

                if (x.status) {

                  var datax = x.data;
                  data.totalTelat = datax.telat;
                  data.totalNunggak = datax.nunggak;

                }

              });
          },
          datae(type) {
            data.page = type;
            if (type == 'all') {
              data.title = "Pelanggan";
            } else if (type == 'belum') {
              data.title = "Pelanggan Belum";
            } else if (type == 'lunasnow') {
              data.title = "Lunas Bayar";
            } else if (type == 'lunas') {
              data.title = "Pelanggan Lunas";
            } else if (type == 'lunas-online') {
              data.title = "Pelanggan Lunas Online";
            } else if (type == 'baru') {
              data.title = "Pelanggan Baru";
            } else if (type == 'isolir') {
              data.title = "Isolir!!";
            }
          }
        }
        return {
          data,
          get,
          myGlobal
        }
    },
    mounted () {
      document.title = "Pelanggan";
      
      //console.log("remove sementara");
      //sessionStorage.removeItem("pelangganSementara");
      
      this.get.dataTotal();
      this.get.datae("all");
      this.data.ppn = myGlobal.PPN();

      this.get.getDataTelat();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.tombol {
  cursor: pointer;
}
.info {
  position: absolute;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  z-index: 999999999;
  margin-top: -50px;
}

.menu-icon {
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pelanggan/main.vue